// ======================================================================
// File Name       : group
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const GROUP_RECEIVE_STRUCTURE_LIST = 'GROUP_RECEIVE_STRUCTURE_LIST';
export const GROUP_INIT_EDITING = 'GROUP_INIT_EDITING';
export const GROUP_RESET_INIT_DATA = 'GROUP_RESET_INIT_DATA';
export const GROUP_RECEIVE_EDITING_GROUP = 'GROUP_RECEIVE_EDITING_GROUP';
export const GROUP_RECEIVE_USER_GROUP = 'GROUP_RECEIVE_USER_GROUP';

export const GROUP_RECEIVE_EDITING_USER_ADMIN = 'GROUP_RECEIVE_EDITING_USER_ADMIN';
export const GROUP_RECEIVE_SEARCH_CONDITION_ADMIN = 'GROUP_RECEIVE_SEARCH_CONDITION_ADMIN';
export const GROUP_RECEIVE_SEARCH_RESULT_ADMIN = 'GROUP_RECEIVE_SEARCH_RESULT_ADMIN';

export const GROUP_RECEIVE_EDITING_USER_NOT_ADMIN = 'GROUP_RECEIVE_EDITING_USER_NOT_ADMIN';
export const GROUP_RECEIVE_SEARCH_CONDITION_NOT_ADMIN = 'GROUP_RECEIVE_SEARCH_CONDITION_NOT_ADMIN';
export const GROUP_RECEIVE_SEARCH_RESULT_NOT_ADMIN = 'GROUP_RECEIVE_SEARCH_RESULT_NOT_ADMIN';

export const SELECTED_GROUP_ON_DIALOG = 'SELECTED_GROUP_ON_DIALOG';
export const SELECTED_GROUP_IDS_ON_DIALOG = 'SELECTED_GROUP_IDS_ON_DIALOG';

export const RECEIVED_USER_ID_LIST = 'RECEIVED_USER_ID_LIST';

export const REMOVED_SELECTED_GROUP = 'REMOVED_SELECTED_GROUP';

export const REMOVED_SELECTED_GROUP_IDS = 'REMOVED_SELECTED_GROUP_IDS';

export const REMOVE_GROUP_LIST = 'REMOVE_GROUP_LIST';

